import { Component, Schema, defaultValue, type } from "yage/decorators/type";

@Component("ProjectilePierce")
export class ProjectilePierceSchema extends Schema {
  @type("number")
  @defaultValue(0)
  pierceCount: number;
}
